import { configure } from 'web-amplify/configure'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { createServerRunner } from '@aws-amplify/adapter-nextjs'
import { generateServerClientUsingReqRes } from '@aws-amplify/adapter-nextjs/api'
import {
  fetchAuthSession as fetchAuthSessionServer,
  getCurrentUser as getCurrentUserServer
} from 'aws-amplify/auth/server'

const serverRunner = createServerRunner({
  config: configure as any
})

const serverClient = generateServerClientUsingReqRes({
  config: configure as any
})

const createRunner = (context) => (func) =>
  serverRunner.runWithAmplifyServerContext({
    nextServerContext: { response: context.res, request: context.req },
    operation: func
  })

const fetchAuthSession = (context) =>
  serverRunner.runWithAmplifyServerContext({
    nextServerContext: {
      request: context.req,
      response: context.res
    },
    operation: fetchAuthSessionServer
  })

const getCurrentUser = (context) =>
  serverRunner.runWithAmplifyServerContext({
    nextServerContext: {
      request: context.req,
      response: context.res
    },
    operation: (contextSpec) => getCurrentUserServer(contextSpec)
  })

const createGraphql = (context) => (options) =>
  runWithAmplifyServerContext({
    nextServerContext: { request: context.req, response: context.res },
    operation: (ctx) => serverClient.graphql(ctx, options) as any
  })

const { runWithAmplifyServerContext } = serverRunner

export {
  createGraphql,
  createRunner,
  fetchAuthSession,
  getCurrentUser,
  runWithAmplifyServerContext,
  serverClient
}
